import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import authService from '../../api-authorization/AuthorizeService';
import DropdownViewModel from '../../ViewModels/DropdownViewModel';
import AccountListViewModel from './ViewModels/AccountListViewModel';
import AccountTableRow from './AccountTableRow';

interface IAccountTableProps {
    accounts: AccountListViewModel[];
    refresh: (refresh: boolean) => void;
    roles: string | string[];
}

export default function AccountTable(props: IAccountTableProps) {
    const [users, setUsers] = React.useState<DropdownViewModel[]>([]);
    React.useEffect(() => { getData(); }, []);

    const items = props.accounts.map((item, index) =>
        <AccountTableRow key={index} account={item} refresh={props.refresh} users={users} roles={props.roles} />
    );

    const getData = async () => {
        const token = await authService.getAccessToken();

        fetch(`Onboarding/GetUsers`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        })
            .then(response => response.json())
            .then(data => {
                setUsers(data.value);
            })
            .catch(error => {
                console.log('Get team leaders error: ' + error);
            });
    }
    return (
        <TableContainer style={{ maxHeight: "75vh" }}>
            <Table aria-label="client list" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Client</TableCell>
                        <TableCell>Account</TableCell>                       
                        <TableCell>Main Exec</TableCell>
                        <TableCell />
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items}
                </TableBody>
            </Table>
        </TableContainer>
    );
}